import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractPractitionerAssociation } from '../../../models/Entities/Contracts/ContractPractitionerAssociation';
import { ContractProtocolAssociation } from '../../../models/Entities/Contracts/ContractProtocolAssociation';

export default function ContractAssociationsReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;

  switch (a.type) {
    case 'PRACTITIONER_CONTRACTS_DELETE_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (contract) {
        contract.practitioners = (contract.practitioners || []).filter(
          (item: ContractPractitionerAssociation) => item.id !== a.practitionerContractId
        );
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    case 'PRACTITIONER_CONTRACTS_ADD_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.practitionerContract.contractId);
      if (contract) {
        contract.practitioners = [...(contract.practitioners || []), a.practitionerContract];
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    case 'CONTRACT_DISASSOCIATE_FROM_PROTOCOL_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (contract) {
        contract.protocol = (contract.protocol || []).filter(
          (item: ContractProtocolAssociation) => item.protocolId !== a.ProtocolId
        );
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    case 'CONTRACT_ASSOCIATE_TO_PROTOCOL_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractProtocolAssociation.contractId);
      if (contract) {
        contract.protocol = [...(contract.protocol || []), a.contractProtocolAssociation];
      }
      return {
        ...currentState,
        list: contract ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), contract] : currentState.list,
      };
    }
    default:
      return currentState;
  }
}
